import Controller from "../class.Controller.js";

export default class TransporterAnalyticsEvent extends Controller {
	/**
	 * @param {object} options
	 * @param {object} options.attributes
	 * @param {TransporterAnalytics} options.attributes.controller
	 */
	constructor(options) {
		super(options);
	}
}
